import { render, staticRenderFns } from "./Usuario_Marcas.vue?vue&type=template&id=b22137a2&scoped=true&"
import script from "./Usuario_Marcas.vue?vue&type=script&lang=js&"
export * from "./Usuario_Marcas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22137a2",
  null
  
)

export default component.exports